import React from "react";

import { variationPercent } from "../btpSummary";

const CBSScore = ({ gameStatus }) => {
  const { score_dic } = gameStatus;
  const cbsScore = score_dic.cbs?.value || 0;
  const cbsScoreStandard = score_dic.cbs?.standard_value;
  // Même convention que les empreintes eau : négatif = moins d'impact que le
  // standard, et la base est le standard (btpSummary.js).
  const variation = -(variationPercent(cbsScore, cbsScoreStandard) ?? 0);
  var submetrics = Object.values(score_dic)
    .filter((item) => item.type === "cbs-submetric")
    .sort((a, b) => a.coef - b.coef);

  const formatValue = (value) => {
    return value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  };

  return (
    <div className="cbs-graph-container">
      <div className="water-footprint-title">Impact Grand Cycle de l'eau</div>
        <div className="water-footprint-header"> 
          <div className="water-footprint-header-content">
            <img className="water-footprint-icon" src="/icon/biodiversity.png" alt="Icone Biodiversité" />
            <div className="water-footprint-score">{cbsScore.toFixed(2)}</div>
          </div>
          <div className="water-footprint-detail-1">{variation}% d'impact</div>
          <div className="water-footprint-detail-2">par rapport au projet standard (CBS : {cbsScoreStandard})</div>
        </div>
      <table className="cbs-graph-table">
        <thead>
          <tr>
            <th>Type de sol</th>
            <th>Surface</th>
            <th>Part</th>
            <th>Coefficient</th>
          </tr>
        </thead>
        <tbody>
          {submetrics.map((metric, index) => {
            const surface = Math.round(metric.corrected_value*score_dic.surface.value || 0);
            const coef = metric.coef || 0;
            const score = metric.corrected_value * coef;

            return (
              <tr key={index} className="cbs-graph-row">
                {/* Icône avec Tooltip */}
                <td className="relative">
                  {metric.icon && (
                    <div className="group">
                      <img
                        src={metric.icon}
                        alt=""
                        className="cbs-graph-icon"
                      />
                      <div className="cbs-graph-tooltip">
                        {metric.name}
                      </div>
                    </div>
                  )}
                </td>

                <td>{formatValue(surface)} m²</td>
                <td>
                  <div className="cbs-graph-progress-bar">
                    <div
                      className="cbs-graph-progress-fill"
                      style={{ width: `${metric.corrected_value * 100}%` }}
                    />
                  </div>
                </td>
                <td>{coef}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default CBSScore;
